<div class="modal inmodal fade in parcel-modal create-modal create-edit-parcel-modal add-settings-amenities-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title col-sm-8">New Amenity</h4>
                    <div class="input-group-btn pull-right">
                        <button tabindex="-1" class="btn btn-primary submit" type="submit"
                                [disabled]="disabledSubmit || settingsAmenitiesService.modalSpinnerShow">
                            Save
                        </button>
                        <button data-toggle="dropdown"
                                class="btn btn-primary dropdown-toggle"
                                type="button"
                                aria-expanded="false">
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu pull-right" style="z-index: 1001;">
                            <li><a (click)="hideModal()">Cancel</a></li>
                        </ul>
                    </div>
                </div>
                <div class="modal-body">
                    <!-- ___ Amenity Name ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Amenity Name</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <input class="form-control" name="name" [ngModel]="data.name" required>
                        </div>
                    </div>

                    <!-- ___ Internal ID ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Internal ID</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            <input class="form-control" name="internalId" [ngModel]="data.internalId">
                        </div>
                    </div>

                    <div class="row m-b-sm" *ngFor="let val of uses; trackBy: trackByFn; let index = index;">
                        <div class="dv-label col-sm-4 strong">
                            {{index > 0 ? '' : 'Uses'}}
                        </div>

                        <div class="dv-value-edit col-sm-8">
                            <input class="form-control"
                                   [(ngModel)]="uses[index]"
                                   name="input{{index}}"
                                   maxlength="255">
                            <button type="button" (click)="addNewUse(index)">
                                <i class="fa icon-plus pull-right" title="Add"></i>
                            </button>
                            <button type="button" (click)="removeUse(index)" *ngIf="index != 0">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </div>

                    <!-- ___ Image  ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Image</label>
                        </div>
                        <div class="col-md-3 detailed-view-image">
                            <input type="file"
                                   name="amenityImage"
                                   accept=".gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff"
                                   id="add-amenity-image-modal-img"
                                   (change)="addImage($event)"
                                   [hidden]="true"
                                   [disabled]="disabledFileInput">
                            <label for="add-amenity-image-modal-img" class="mtv-primary-color">
                                <div class="placeholder" *ngIf="!data.amenityImage"></div>
                                <div class="amenity-image-svg"
                                     *ngIf="data.amenityImage && data.amenityImage.slice(-4) == '.svg'"
                                     [ngStyle]="{'mask-image': 'url(' + data.amenityImage + ')',
                                                 '-webkit-mask-image': 'url(' + data.amenityImage + ')'}">
                                </div>
                                <img *ngIf="data.amenityImage && data.amenityImage.slice(-4) != '.svg'"
                                     [src]="data.amenityImage">
                            </label>
                        </div>
                        <div class="col-md-5 image-picker">
                            <i class="fa fa-chevron-left mtv-primary-color" (click)="showPreviousAmenityImage()"></i>
                            <div class="amenity-image-svg"
                                 (click)="data.amenityImage = (amenityImageBasePath + displayedAmenityImage)"
                                 [ngStyle]="{'mask-image': 'url(' + amenityImageBasePath + displayedAmenityImage + ')',
                                             '-webkit-mask-image': 'url(' + amenityImageBasePath + displayedAmenityImage + ')'}">
                            </div>
                            <i class="fa fa-chevron-right mtv-primary-color" (click)="showNextAmenityImage()"></i>
                        </div>
                        <spinner [spinnerShow]="disabledFileInput"></spinner>
                    </div>

                    <!-- ___ Allow Residents To Book  ___ -->
                    <div class="row m-b-sm col-md-12">
                        <label class="img-checkbox">
                            <input id="allowResidentsToBook"
                                   type="checkbox"
                                   name="allowResidentsToBook"
                                   #allowResidentsToBook
                                   [ngModel]="data.allowResidentsToBook">
                            <label for="allowResidentsToBook"><svg-checked></svg-checked></label>
                            <span>Allow Residents To Book</span>
                        </label>
                    </div>

                    <!-- ___ Require Managers Approval  ___ -->
                    <div class="row m-b-sm col-md-12">
                        <label class="img-checkbox">
                            <input id="requiresManagerApproval"
                                   type="checkbox"
                                   name="requiresManagerApproval"
                                   [ngModel]="data.requiresManagerApproval">
                            <label for="requiresManagerApproval"><svg-checked></svg-checked></label>
                            <span>Require Managers Approval</span>
                        </label>
                    </div>

                    <!-- ___ Buildings  ___ -->
                    <div class="row m-b-sm" style="overflow: visible;">
                        <div class="col-md-4 m-t-xs apart-btns">
                            <label>Buildings</label>
                        </div>
                        <div class="col-md-8">
                            <angular2-multiselect
                                name="buildings"
                                [data]="settingsAmenitiesService.buldingsInMultiselectFormat"
                                [(ngModel)]="data.buildingAmenity"
                                [settings]="multiselectSettings" required>
                            </angular2-multiselect>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>
<view-attachment-modal *ngIf="settingsAmenitiesService.es.isViewAttachmentModalShow"></view-attachment-modal>



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/settings-amenities-modal/settings-amenities-modal.component.html